import $ from 'jquery';
import { loadModal } from '../../AsyncLoader';
import dom from '../../utils/dom';
import ForgotPasswordService from './ForgotPasswordService';
import Component from './ForgotPasswordComponent';
import ConfirmationModal from './ForgotPasswordConfirmationModal';

const FORM_ID = 'tn-account-login-forgot-password-form';
const { formButtonHandler } = window.tnew.handlers;
const { FieldValidationProvider } = window.tnew.lib;

class ForgotPasswordModalProvider {
  constructor() {
    this.$username = $('#ForgotLogin_Username');
    this.$resetLink = $('#tn-account-login-forgot-login-link');
    this.$form = $('#tn-account-login-forgot-password-form');
    this.$inputLoginEmail = $('#PatronAccountLogin_Username');
    this.$errorMessage = $('#tn-account-login-forgot-password-failure-message');
  }

  listen() {
    this.$resetLink.on('click', () => {
      this.setUpFormFields();
      this.showModal();
    });

    FieldValidationProvider.createStandardProvider(this.$form[0]);
  }

  setUpFormFields() {
    const loginEmailValue = this.$inputLoginEmail.val();

    if (loginEmailValue) {
      this.$username.val(loginEmailValue);
      this.$username.blur();
    }
  }

  async showModal() {
    let modal;

    const $submitButton = this.makeModalSubmitButton(Component.sendEmailButtonText);
    const $cancelButton = this.makeModalCancelbutton(Component.cancelButtonText);

    $submitButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.processForm($submitButton);
    });

    $cancelButton.addEventListener('click', () => {
      modal.close();
    });

    this.$errorMessage.hide();

    const Modal = await loadModal();

    modal = Modal.open({
      title: Component.heading,
      bodyContents: this.$form,
      footerContents: [$cancelButton, $submitButton],
      returnFocusTo: this.$resetLink[0],
    });

    this.modal = modal;
  }

  makeModalSubmitButton(labelHtml) {
    const $btn = dom.makeElement('button', {
      type: 'submit',
      class: 'modal-btn-confirm btn btn-primary tn-account-login-forgot-password-button-submit',
      form: FORM_ID,
    });

    $btn.innerHTML = labelHtml;

    return $btn;
  }

  makeModalCancelbutton(labelHtml) {
    const $btn = dom.makeElement('button', {
      type: 'button',
      class: 'modal-btn-cancel btn btn-default',
    });

    $btn.innerHTML = labelHtml;

    return $btn;
  }

  async processForm(submitButton) {
    const email = this.$username.val();

    if (!email) {
      this.$username.blur(); // Triggering field validation
      this.$username.focus();

      return;
    }

    formButtonHandler.applyBusyStyling(submitButton);

    await this.post(email);

    formButtonHandler.resetStyling(submitButton);
  }

  async post(emailAddress) {
    this.$errorMessage.hide();

    const response = await ForgotPasswordService.resetLogin(emailAddress);

    if (response.isSuccess) {
      this.modal.close();

      ConfirmationModal.open({
        emailAddress,
        returnFocusTo: this.$resetLink[0],
      });
    } else {
      this.$errorMessage.html(response.message);
      this.$errorMessage.show();
    }
  }
}

export default ForgotPasswordModalProvider;



// WEBPACK FOOTER //
// ./src/account/login/ForgotPasswordModalProvider.js